<template>
    <div>
        <div class="d-flex justify-center">
            <img :src="volvicImage" alt="Soirée Volvic 50 ans" class="banniere_volvic">
        </div>

        <div class="d-flex flex-column justify-center">
            <div class="text-h5 font-weight-bold mb-2 text-center text-uppercase">Célébrons ensemble les 50 ans du site
                d'embouteillage
                de Volvic !</div>
            <div class="text-h5 font-weight-bold mb-2 text-center">- SAMEDI 17 MAI 2025 -</div>
            <div>Rejoignez-nous pour une journée festive et conviviale pour découvrir les secrets de l'eau minérale
                naturelle Volvic !<br> De sa genèse au cœur du territoire, à son embouteillage en passant par les
                actions
                mises en place pour préserver cette ressource précieuse, nous vous accueillons dans un cadre unique et
                chargé d'histoire.</div>
            <div class="font-weight-bold mt-3 text-uppercase mb-2">Au programme :</div>
            <div class="mb-2">
                <v-icon icon="mdi-square-small" color="primary-dark"></v-icon><u>Visite du site d’embouteillage de
                    Volvic</u>
                - <i>Inscription obligatoire</i>
            </div>
            <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon><u>Visite de l’impluvium de
                    Volvic</u> :
                Explorez cette zone naturelle protégée et apprenez-en plus les actions mises en place pour préserver
                cette ressource précieuse - <i>Inscription obligatoire</i></div>
            <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon><u>Défis de l'Eau</u> :
                Participez à
                des activités
                ludiques et éducatives pour toute la famille afin de comprendre le fonctionnement de l'impluvium et la
                singularité de l'eau minérale naturelle Volvic - <i>Accès libre au Parc de la Source</i></div>
            <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon><u>Initiation au rugby</u> :
                Rejoignez-nous pour
                une initiation au rugby animée par la section rugby de l'ASM Omnisport - <i>Accès libre au Parc de la
                    Source</i></div>
            <div class="mt-3">Nous vous attendons nombreux, petits et grands, pour célébrer ensemble les 50 ans du site
                d'embouteillage de l'eau minérale naturelle Volvic.</div>

        </div>
        <hr>
    </div>
</template>

<script>
import volvicImage from '@/assets/img/volvic_50_noborder.jpg'

export default {
    data() {
        return {
            volvicImage
        }
    }
}
</script>

<style lang="scss" scoped>
.banniere_volvic {
    width: 100%;
    height: auto;
    border-radius: 3px;
    margin: 0 15px 15px 15px;
}
</style>